module.exports = __webpack_public_path__ + "img/code-logo-w.39b88dc7.png";